export enum AceInvitationOriginEnum {
  AWS = 'aws',
  PARTNER = 'partner',
}
